import { createConfirmation } from "react-confirm";
import RepeatModal from "./RepeatModal";

export const showRepeatModal = createConfirmation(RepeatModal);
